<template>
  <div class="container page" style="background-color: #1f1c1f">
    <van-nav-bar :title="$t('setting.sex_place')" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
    </van-nav-bar>
    <div class="sex">
      <van-radio-group v-model="radio">
        <div class="item van-hairline--bottom" @click="chooesSex(1)">
          <van-radio name="1">{{ $t("setting.man") }}</van-radio>
        </div>
        <div class="item van-hairline--bottom" @click="chooesSex(2)">
          <van-radio name="2">{{ $t("setting.female") }}</van-radio>
        </div>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "",
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    chooesSex(sex) {
      this.$http({
        method: "post",
        data: { sex: sex },
        url: "user_set_sex",
      }).then((res) => {
        if (res.code === 200) {
          this.getUserInfo();
          this.radio = sex;
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      console.log(window.localStorage.getItem("lang").toLowerCase());
      this.$http({
        method: "get",
        url: "user_info",
        headers: {
          lang: window.localStorage.getItem("lang").toLowerCase(),
        },
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.radio = res.data.sex;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
/deep/ .van-field__label {
  color: #ccc;
}
.van-cell-group {
  background-color: transparent;
  padding: 30px 0;
  &:after {
    display: none;
  }
}
.van-cell {
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  /deep/ .van-field__control {
    color: #f3c7a2;
  }
  &:after {
    display: none;
  }
}
.container .sex {
  // background-color: #fff;
  padding: 0 40px;
}
.container .sex .item {
  font-size: 35px;
  line-height: 50px;
  padding: 30px 0;
}
::v-deep .van-radio__label {
  line-height: 50px;
  margin-left: 30px;
  color: #f3c7a2;
}
::v-deep .van-radio__icon {
  font-size: 30px;
}
::v-deep .van-radio__icon--checked .van-icon {
  color: #fff;
  border-color: #f3c7a2;
  background-color: #f3c7a2;
}
.container .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }
  .nav-bar {
    height: 50px;
  }
  .container .sex {
    padding: 0 15px;
  }
  .container .sex .item {
    padding: 10px;
    font-size: 16px;
  }
  ::v-deep .van-radio__icon {
    font-size: 25px;
  }

  ::v-deep .van-radio__label {
    line-height: 50px;
  }
}
</style>
